import {useMutation, gql} from '@apollo/client'
import {useMsal} from '@azure/msal-react'
import {getAccessToken} from '../helper/authHelper'

const downloadUrl =
  process.env.NODE_ENV === 'production' ? globalThis.__env.REACT_APP_API_URL : process.env.REACT_APP_API_URL

export const MUTATE_EXPORT_LIST = gql`
  mutation MUTATE_EXPORT_LIST(
    $fileType: String!
    $startIndex: Int!
    $limit: Int!
    $filters: ProspectFilters
    $selectedColumns: [String]!
    $azureRole: String
    $listName: String
    $sortColumn: String
    $sortDirection: String
    $filteredList: Boolean
  ) {
    exportList(
      fileType: $fileType
      startIndex: $startIndex
      limit: $limit
      filters: $filters
      selectedColumns: $selectedColumns
      azureRole: $azureRole
      listName: $listName
      sortColumn: $sortColumn
      sortDirection: $sortDirection
      filteredList: $filteredList
    ) {
      fileHash
      fileType
    }
  }
`

const handleCompleted = async (
  data,
  instance,
  accounts,
  inProgress,
  onDownloadError,
  onDownloadComplete,
  documentName
) => {
  try {
    const accessToken = await getAccessToken(instance, accounts, inProgress)
    const exportFile = data?.exportList?.fileHash
    const fileType = data?.exportList?.fileType
    if (!exportFile || !fileType) {
      throw new Error('Invalid response from server: Missing file information.')
    }
    const exportHash = `${downloadUrl}/export_prospects/${exportFile}/${fileType}`
    const defaultFileName = `${documentName}.${fileType}`
    await fetchExportFile(exportHash, defaultFileName, accessToken)
    if (onDownloadComplete) {
      onDownloadComplete()
    }
  } catch (error) {
    console.error('Error downloading file:', error)
    if (onDownloadError) {
      onDownloadError('Error occurred while downloading the file. Please try again.')
    }
  }
}

export default function useExportList(onDownloadError, onDownloadComplete, documentName) {
  const {instance, accounts, inProgress} = useMsal()
  return useMutation(MUTATE_EXPORT_LIST, {
    onCompleted: (data) =>
      handleCompleted(data, instance, accounts, inProgress, onDownloadError, onDownloadComplete, documentName),
    onError: (error) => {
      console.error('Export list mutation error:', error)
      if (onDownloadError) {
        onDownloadError('Error occurred while exporting the list. Please try again.')
      }
    },
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  })
}

// Code that relies heavily on manipulating browser elements
export const fetchExportFile = async (exportUrl, fileName, accessToken) => {
  try {
    const response = await fetch(exportUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()
    const url = globalThis.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)

    document.body.appendChild(link)
    link.click()
    link.remove()

    // Clean up the URL object
    globalThis.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error fetching export file:', error)
    throw error
  }
}
